import React from 'react';
import { Pagination } from 'antd';
class CustomerPage extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            pageMeta: this.props.data,
            infotitle: this.props.infotitle || '合计 '
        };
    }

    //点击下标改变页面
    onPageChange = (page, pageSize) => {
        this.props.onChange(page);
    }
    //列表显示最多条数
    onShowSizeChange = (current, pageSize) => {
        this.props.onShowSizeChange(current, pageSize);
    }
    componentWillReceiveProps(nextProps: any) {
        if (nextProps.data !== this.props.data) {
            this.setState({
                pageMeta: nextProps.data,
            });
        }
    }
    render() {
        const { pageMeta, infotitle } = this.state;
        return (
            <div style={{ 'margin': '24px 0', 'position': 'relative' }}>
                <Pagination
                    total={pageMeta.total}
                    current={pageMeta.pageNum}
                    pageSize={pageMeta.pageSize}
                    showTotal={(total, range) => {
                        if (total > 0) {
                            return <span>当前 {range[0]}-{range[1]}{!this.props.hideTotal && <span className="page-total">{infotitle} <span className="number">{total}</span> </span>}</span>;
                        } else {
                            return '';
                        }
                    }}
                    onChange={this.onPageChange}
                    onShowSizeChange={this.onShowSizeChange}
                    showSizeChanger={pageMeta.total > 0 ? true : false}
                />
            </div>
        );
    }
}
export default CustomerPage;



// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/display/components/PageUi/index.tsx